import { render, staticRenderFns } from "./ModalVincularCarObrigatorioTerritorio.vue?vue&type=template&id=71481d5e&lang=pug"
import script from "./ModalVincularCarObrigatorioTerritorio.vue?vue&type=script&lang=js"
export * from "./ModalVincularCarObrigatorioTerritorio.vue?vue&type=script&lang=js"
import style0 from "./ModalVincularCarObrigatorioTerritorio.vue?vue&type=style&index=0&id=71481d5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports